import { computed, ref, toRaw, watch } from 'vue'
import axios from 'axios'
import useSwal from '@/modules/Swal.js'

const states = ref([])
const filtered_states = ref([])
const state_filters = ref({
  name: '',
})

const cities = ref([])
const filtered_cities = ref([])
const city_filters = ref({})

const address = ref({
  state: '',
  street: '',
  city: '',
  neighborhood: '',
})

export default function useAddresses() {
  const { showErrorDialog } = useSwal()

  const listStates = async () => {
    await axios
      .get('/api/states/all')
      .then(function (response) {
        states.value = filtered_states.value = response.data.data
      })
      .catch(function () {})
  }

  const listCitiesByStateShortName = async (state_name) => {
    await axios
      .get('/api/cities/getByStateShortName/' + state_name)
      .then(function (response) {
        cities.value = filtered_cities.value = response.data.data
      })
      .catch(function () {})
  }

  const updateStateFilters = async () => {
    let filters = toRaw(state_filters.value)

    filtered_states.value = states.value.filter((row) => {
      let state = toRaw(row)
      let matches = 0

      for (let key of Object.keys(filters)) {
        if (filters[key].toString().trim() == '') {
          matches++
          continue
        }

        if (
          state[key]
            .toString()
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), '')
            .includes(
              filters[key]
                .toString()
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), ''),
            )
        ) {
          matches++
        }
      }

      return matches == Object.keys(filters).length
    })
  }

  watch(state_filters.value, () => {
    setTimeout(() => {
      updateStateFilters()
    }, 250)
  })

  const updateCityFilters = async () => {
    let filters = toRaw(city_filters.value)

    filtered_cities.value = cities.value.filter((row) => {
      let city = toRaw(row)
      let matches = 0

      for (let key of Object.keys(filters)) {
        if (filters[key].toString().trim() == '') {
          matches++
          continue
        }

        if (
          city[key]
            .toString()
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), '')
            .includes(
              filters[key]
                .toString()
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), ''),
            )
        ) {
          matches++
        }
      }

      return matches == Object.keys(filters).length
    })
  }

  watch(city_filters.value, () => {
    setTimeout(() => {
      updateCityFilters()
    }, 250)
  })

  const findAddressByPostalCode = async (postal_code) => {
    //let postal_code = this.company.company_address.postal_code.replace("-", ""); - Habilitar caso tenha máscara no CEP
    await axios
      .get('/api/address/get?cep=' + postal_code)
      .then((response) => {
        address.value.state = response.data.uf
        address.value.street = response.data.logradouro
        address.value.city = response.data.localidade
        address.value.neighborhood = response.data.bairro
      })
      .catch((error) => {
        console.log({ error })
        const message = error?.response?.data?.error || 'Preencha Estado e Cidade manualmente.'
        showErrorDialog('Não foi possível buscar o endereço pelo CEP. ' + message)
      })
  }

  return {
    states: computed(() => states.value),
    filtered_states: computed(() => filtered_states.value),
    state_filters,
    listStates,
    cities: computed(() => cities.value),
    filtered_cities: computed(() => filtered_cities.value),
    city_filters,
    address,
    findAddressByPostalCode,
    listCitiesByStateShortName,
  }
}
